// Auto generated file, do not manually modify!
// com.hotpads.rins.api.web.handler.UpsellWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  UpsellWebApiHandler_clickUpsell,
  UpsellWebApiHandler_createUpsell,
  UpsellWebApiHandler_optOutFromUpsell,
  UpsellWebApiHandler_shouldDisplayUpsell,
  UpsellWebApiHandler_shouldDisplayUpsell_Path,
  UpsellWebApiHandler_viewUpsell,
} from '@zg-rentals/ts-rins-client';

import type {
  ClickUpsellWebApiRequestDto,
  CreateUpsellWebApiRequestDto,
  CreateUpsellWebApiResponseDto,
  OptOutFromUpsellWebApiRequestDto,
  ShouldDisplayUpsellWebApiRequestDto,
  ViewUpsellWebApiRequestDto,
} from '@zg-rentals/ts-rins-client';

export interface UpsellWebApiHandler_clickUpsell_Args {
  postData: ClickUpsellWebApiRequestDto;
}

export type UpsellWebApiHandler_clickUpsell_Options = UseMutationOptions<
  void,
  unknown,
  UpsellWebApiHandler_clickUpsell_Args
>;

/**
 * user clicks an upsell
 */
export const useUpsellWebApiHandler_clickUpsell = ({
  httpClient,
  ...options
}: Omit<UpsellWebApiHandler_clickUpsell_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: UpsellWebApiHandler_clickUpsell_Args) =>
      UpsellWebApiHandler_clickUpsell(args.postData, httpClient),
  });
};

export interface UpsellWebApiHandler_createUpsell_Args {
  postData: CreateUpsellWebApiRequestDto;
}

export type UpsellWebApiHandler_createUpsell_Options = UseMutationOptions<
  CreateUpsellWebApiResponseDto,
  unknown,
  UpsellWebApiHandler_createUpsell_Args
>;

/**
 * creates an upsell using a tracking id
 */
export const useUpsellWebApiHandler_createUpsell = ({
  httpClient,
  ...options
}: Omit<UpsellWebApiHandler_createUpsell_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: UpsellWebApiHandler_createUpsell_Args) =>
      UpsellWebApiHandler_createUpsell(args.postData, httpClient),
  });
};

export interface UpsellWebApiHandler_optOutFromUpsell_Args {
  postData: OptOutFromUpsellWebApiRequestDto;
}

export type UpsellWebApiHandler_optOutFromUpsell_Options = UseMutationOptions<
  void,
  unknown,
  UpsellWebApiHandler_optOutFromUpsell_Args
>;

/**
 * user opts out from upsells
 */
export const useUpsellWebApiHandler_optOutFromUpsell = ({
  httpClient,
  ...options
}: Omit<UpsellWebApiHandler_optOutFromUpsell_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: UpsellWebApiHandler_optOutFromUpsell_Args) =>
      UpsellWebApiHandler_optOutFromUpsell(args.postData, httpClient),
  });
};

export type UpsellWebApiHandler_shouldDisplayUpsell_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  Array<string | ShouldDisplayUpsellWebApiRequestDto>
>;

const UpsellWebApiHandler_shouldDisplayUpsell_GetKey = (postData: ShouldDisplayUpsellWebApiRequestDto) => [
  UpsellWebApiHandler_shouldDisplayUpsell_Path,
  postData,
];

/**
 * should an upsell be displayed to a user
 */
export const useUpsellWebApiHandler_shouldDisplayUpsell = (
  postData: ShouldDisplayUpsellWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<UpsellWebApiHandler_shouldDisplayUpsell_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: UpsellWebApiHandler_shouldDisplayUpsell_GetKey(postData),
    queryFn: () => UpsellWebApiHandler_shouldDisplayUpsell(postData, httpClient),
  });
};
useUpsellWebApiHandler_shouldDisplayUpsell.getKey = UpsellWebApiHandler_shouldDisplayUpsell_GetKey;

export interface UpsellWebApiHandler_viewUpsell_Args {
  postData: ViewUpsellWebApiRequestDto;
}

export type UpsellWebApiHandler_viewUpsell_Options = UseMutationOptions<
  void,
  unknown,
  UpsellWebApiHandler_viewUpsell_Args
>;

/**
 * user views an upsell
 */
export const useUpsellWebApiHandler_viewUpsell = ({
  httpClient,
  ...options
}: Omit<UpsellWebApiHandler_viewUpsell_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: UpsellWebApiHandler_viewUpsell_Args) =>
      UpsellWebApiHandler_viewUpsell(args.postData, httpClient),
  });
};
